import { Component, Input } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Notification } from '@base/entities/BaseEntities';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    providers: ServiceBagServices,
    selector: 'app-email-history-item',
    templateUrl: './email-history-item.component.html',
    styleUrls: ['./email-history-item.component.scss']
})
export class EmailHistoryItemComponent extends BaseComponent<BaseState> {

    @Input() Entity: Notification;

    constructor(A: ServiceBagService,
        public sanitizer: DomSanitizer) {
        super(A, 'EmailHistoryItemComponent', BaseState);
    }
}
